"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 10 15';

var QuestionMark = function QuestionMark() {
  return _react["default"].createElement("path", {
    d: "M5,0.706521739 C2.70868278,0.706521739 0.833333333,2.54110598 0.833333333,4.7826087 C0.829083092,5.07660537 0.986979413, 5.35006633 1.24656071,5.49827803 C1.506142,5.64648974 1.82719133,5.64648974 2.08677263,5.49827803 C2.34635392, 5.35006633 2.50425024,5.07660537 2.5,4.7826087 C2.5,3.42225815 3.60941722,2.33695652 5,2.33695652 C6.39058278, 2.33695652 7.5,3.42225815 7.5,4.7826087 C7.5,5.62859783 7.15135889,6.2061087 6.57986111,6.79517663 C6.00836333, 7.38423913 5.21542417,7.91735054 4.47916667,8.4935462 C4.28150528,8.6483768 4.16652055,8.88272066 4.16666667, 9.13043478 L4.16666667,10.2173913 C4.16241643,10.511388 4.32031275,10.7848489 4.57989404,10.9330606 C4.83947534, 11.0812723 5.16052466,11.0812723 5.42010596,10.9330606 C5.67968725,10.7848489 5.83758357,10.511388 5.83333333, 10.2173913 L5.83333333,9.52955163 C6.44048639,9.07615489 7.15351444,8.57745924 7.79513889,7.91610054 C8.54308556, 7.14517663 9.16666667,6.10529076 9.16666667,4.7826087 C9.16666667,2.54110598 7.29131722,0.706521739 5,0.706521739 Z M5, 12.1195652 C4.38635,12.1195652 3.88888889,12.6061957 3.88888889,13.2065217 C3.88888889,13.8068207 4.38635,14.2934783 5, 14.2934783 C5.61365,14.2934783 6.11111111,13.8068207 6.11111111,13.2065217 C6.11111111,12.6061957 5.61365,12.1195652 5,12.1195652 Z"
  });
};

var _default = (0, _createSvgIcon["default"])(QuestionMark, {
  viewBox: viewBox
});

exports["default"] = _default;